export default __webpack_public_path__ + "static/media/cpt-boomerang.45ecf130.png";